import { JureCdc } from './jure-cdc.model';

export class JureExport extends JureCdc {
    static jsonMap = {
        ...JureCdc.jsonMap,
        libelleCollege: { key: 'libelleCollege', optional: true, default: '' },
        cahierDesCharges: { key: 'cahierDesCharges', default: () => [] }
    };

    libelleCollege: string;
    cahierDesCharges: string[];
}
